// File: app/src/components/ChatMessages.jsx
import React, { useRef, useEffect, useState } from 'react';

export default function ChatMessages({ messages = [], isTyping = false }) {
  const containerRef = useRef(null);
  const bottomRef = useRef(null);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);

  const handleScroll = () => {
    if (!containerRef.current) return;
    const el = containerRef.current;
    const atBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 50;
    setShouldAutoScroll(atBottom);
  };

  const typingMessages = [
    "The Great Old Ones are contemplating your question...",
    "The Great Old Ones are conferring across dimensions...",
    "The Great Old Ones consult the archives of R'lyeh...",
    "The Great Old Ones ponder this query in their deathless slumber...",
    "The Great Old Ones whisper secrets through the void...",
    "The Great Old Ones access memories older than the Earth...",
    "The Great Old Ones are deliberating in languages that predate human speech...",
    "The Great Old Ones convene in the spaces between stars...",
    "The Great Old Ones are contemplating your question from beyond the veil of reality...",
    "The Great Old Ones consider your words across the gulfs of time...",
    "The Great Old Ones weigh your inquiry against cosmic truths...",
    "The Great Old Ones draw from wells of primordial knowledge...",
    "The Great Old Ones stir in their eternal vigil...",
    "The Great Old Ones reach across the threshold of understanding...",
    "The Great Old Ones decode the mysteries you seek...",
    "The Great Old Ones align their ancient wisdom...",
    "The Great Old Ones commune through dreams and whispers..."
  ];
  
  const getRandomTypingMessage = () => {
    return typingMessages[Math.floor(Math.random() * typingMessages.length)];
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (shouldAutoScroll && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isTyping, shouldAutoScroll]);

  return (
    <div 
      ref={containerRef}
      style={{
        flex: 1,
        overflowY: 'auto',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem'
      }}
    >
      {Array.isArray(messages) && messages.map((msg, idx) => (
        <div 
          key={idx} 
          style={{
            padding: '0.75rem',
            borderRadius: '0.5rem',
            backgroundColor: msg.type === 'user' ? '#EBF5FF' : '#F3F4F6',
            alignSelf: msg.type === 'user' ? 'flex-end' : 'flex-start',
            maxWidth: '80%',
            whiteSpace: 'pre-wrap'
          }}
        >
          {typeof msg.text === 'string' ? msg.text : ''}
        </div>
      ))}
      {isTyping && (
        <div style={{ fontStyle: 'italic', color: '#9CA3AF' }}>
          {getRandomTypingMessage()}
        </div>
      )}
      <div ref={bottomRef} />
    </div>
  );
}